import CryptoJS from 'crypto-js';

const CRYPTO_KEY = '612ppucd';

export function encryptByDESModeCBC(message: string) {
  const keyHex = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  const ivHex = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export function decryptByDESModeCBC(ciphertext: string) {
  const keyHex = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  const ivHex = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  return CryptoJS.DES.decrypt(
    // @ts-ignore
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext),
    },
    keyHex,
    {
      iv: ivHex,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  ).toString(CryptoJS.enc.Utf8);
}
